<fc-content-header-summary [content]="content" [analyticsMode]="analyticsMode">
    <ng-container *ngIf="verticals">
        <fc-category-card-v2 [categories]="verticals.categories" [isDetailed]="true"
            [itemCount]="verticals.categories.length"></fc-category-card-v2>
    </ng-container>
</fc-content-header-summary>